// extracted by mini-css-extract-plugin
export var courseIsChosen = "category-course-pill-module--course-is-chosen--93897";
export var hoverNotCurrent = "category-course-pill-module--hover-not-current--5956d";
export var listCounter = "category-course-pill-module--list-counter--025ba";
export var title = "category-course-pill-module--title--caa8c";
export var wrapper = "category-course-pill-module--wrapper--f77a8";